
import { defineComponent,ref,Ref,provide,watchEffect } from 'vue';
import LoginForm from '@/components/LoginForm.component.vue'; // @ is an alias to /src

export default defineComponent({
  name: 'LoginView',
  components:{
    LoginForm
  },
  setup(){
   
 
    //document.body.style.background = 'url('+require("@/img/bg.jpeg")+')';
  }
});
